import { render, staticRenderFns } from "./PhpExtendedSupportSubscriptionGrid.vue?vue&type=template&id=6277f6e4&scoped=true"
import script from "./PhpExtendedSupportSubscriptionGrid.vue?vue&type=script&lang=js"
export * from "./PhpExtendedSupportSubscriptionGrid.vue?vue&type=script&lang=js"
import style0 from "./PhpExtendedSupportSubscriptionGrid.vue?vue&type=style&index=0&id=6277f6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6277f6e4",
  null
  
)

export default component.exports